import Layout from "../../layout/Layout"
import BlogArticle from "./BlogArticle"


function Blog() {
return (
 <Layout>
         <div
            className="w-full h-screen bg-cover bg-center"
            style={{ backgroundImage: "url('/blog.jpg')" }} // Replace with the correct image URL
        >
            <div className="w-full h-full bg-black opacity-10 absolute top-0 left-0"></div>

            {/* Hero Section Content */}
            <div className="w-full h-full flex items-center justify-center text-white">
                <div className="text-center px-10">
                    <h1 className="text-[55px] font-extrabold leading-tight ">
                        Blogs
                    </h1>
                
                </div>
            </div>
        </div>
        <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-800 mt-5 mx-3">Get inspiration from our latest blogs</h2>
        </div>
        {[...Array(3)].map((_, idx) => (
            <BlogArticle key={idx} />
        ))}
 </Layout>
)
}

export default Blog